import * as React from "react";
import { Box } from "@mui/material";

export default function FadedScrollBox({
  children,
  onKeyDown,
  listRef,
  onMouseDown,
}) {
  const [showBottom, setShowBottom] = React.useState(false);

  const update = React.useCallback(() => {
    const el = listRef.current;
    if (!el) return;
    const canScroll = el.scrollHeight > el.clientHeight + 1;
    const atBottom =
      Math.ceil(el.scrollTop + el.clientHeight) >= el.scrollHeight - 1;
    setShowBottom(canScroll && !atBottom);
  }, []);

  React.useEffect(() => {
    const el = listRef.current;
    if (!el) return;
    el.addEventListener("scroll", update, { passive: true });
    const ro = new ResizeObserver(update);
    ro.observe(el);
    update();
    return () => {
      el.removeEventListener("scroll", update);
      ro.disconnect();
    };
  }, [update]);

  const mask = showBottom
    ? "linear-gradient(to bottom, black 0%, black calc(100% - 32px), transparent 100%)"
    : "none";
  return (
    <Box
      ref={listRef}
      tabIndex={0}
      onKeyDown={onKeyDown}
      onMouseDown={onMouseDown}
      sx={(t) => ({
        "&:focus-visible": {
          boxShadow: `0 0 0 2px ${t.palette.primary.main}55`,
        },
        maxHeight: 280,
        overflowY: "auto",
        // fade the bottom 32px of the *visible area*
        WebkitMaskImage: mask,
        maskImage: mask,
      })}
    >
      {children}
    </Box>
  );
}
